import Grid from "@mui/material/Unstable_Grid2";
import {TextField} from "@mui/material";
import React from "react";
import {AccordionData} from "../../interfaces/AccordionData";

type Props = {
    field: AccordionData,
    index: number,
    handleInputChange: (index: number, newValue: string) => void
}
const SingleInput = ({field, index, handleInputChange}: Props) => {

    return (
        <Grid xs={field.size}>
            <TextField
                fullWidth
                defaultValue={field.value}
                label={field.label}
                onChange={(e) => handleInputChange(index, e.target.value)}
                variant="outlined"/>
        </Grid>
    )
}

export default SingleInput;